export default (that) => [
  {
    field: 'seq',
    minWidth: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    minWidth: 80,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('form_label_purchaseMaterialNo') || '采购单号',
    field: 'purchaseMaterialNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_purchaseStatus') || '单据状态',
    field: 'purchaseStatus',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    slots: {
      default: 'status',
    },
  },
  {
    title: that.$l('form_label_originOrderNo') || '源头订单号',
    field: 'originOrderNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_scmName') || '供应商',
    field: 'scmName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_signPlace') || '签订地点',
    field: 'signPlace',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_buyerName') || '采购人员',
    field: 'buyerName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_purchaseDate') || '制单日期',
    field: 'purchaseDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_totalAmount') || '采购金额',
    field: 'totalAmount',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_reviewByName') || '审核人员',
    field: 'reviewByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_reviewTime') || '审核日期',
    field: 'reviewTime',
    headerAlign: 'center',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: 'displayCreateByName',
    },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: {
      default: 'displayModifyByName',
    },
  },
]
